(function () {

    'use strict';
    angular.module('iplusjs.button.btn', [
        'lodash',
        'iplusjs.utils.button'
    ])
        .directive('iplusjsButtonBtn', buttonBtn);

    ButtonBtnController.$inject = [
        '$attrs',
        '$timeout',
        '$state',
        'lodash',
        'ButtonUtilsService'
    ];
    function ButtonBtnController($attrs, $timeout, $state, _, ButtonUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.isDisabled = isDisabled;
        vm.click = click;

        function onInit() {
            vm.cssClass = ButtonUtilsService.getButtonCls('btn', vm.cls);
            vm.btnDesc = vm.desc;
            vm.options = vm.options || {};

            $attrs.$observe('ibbDesc', function (desc) {
                vm.btnDesc = desc;
            });

            $attrs.$observe('ibbCls', function (cls) {
                vm.cssClass = ButtonUtilsService.getButtonCls('btn', cls);
            });
        }

        function isDisabled() {
            if (!_.isNil(vm.disabled)) {
                return !!vm.disabled;
            }

            if (!vm.formCtrl) {
                return false;
            }

            return !!(vm.formCtrl.$invalid || vm.formCtrl.$pending);
        }

        function click($event) {
            if (vm.uiSref) {
                $timeout(function () {
                    $state.go(vm.uiSref);
                });
            }

            if (_.isFunction(vm.onClick)) {
                $event && $event.stopPropagation();
                vm.onClick();
            }
        }
    }

    buttonBtn.$inject = [];
    function buttonBtn() {
        return {
            restrict: 'EA',
            require: {
                form: '?^form',
                fieldset: '?^iplusjsFieldset'
            },
            scope: {
                disabled: '=ngDisabled',
                type: '@ibbType',
                cls: '@ibbCls',
                desc: '@ibbDesc',
                onClick: '&?ibbOnClick',
                name: '@ibbName',
                uiSref: '@ibbUiSref',
                tracking: '<?ibbTracking',
                options: '<?ibbOptions'
            },
            templateUrl: 'common/button/buttonBtn.html',
            link: function ($scope, $element, $attrs, $formCtrl) {
                $scope.buttonBtnVm.formCtrl = $formCtrl;
            },
            controller: ButtonBtnController,
            controllerAs: 'buttonBtnVm',
            bindToController: true
        };
    }
})();
